function subscriptionaTypeCheck (){

   const urlParams = new URLSearchParams(window.location.search);
    const isAnnual = urlParams.get('type') === 'annual';

    if (isAnnual) {
      const annualInput = document.querySelector('input[name="Selling_plans"][value="6447235359"]');
      if (annualInput) {
        annualInput.click();
      }
    } else {
        const ontimeInput = document.querySelector('.selling-plan_one_bar input.subsription-input');
        if( ontimeInput ) {
          ontimeInput.click();
        }
      }
}


$(document).ready(function () {

  setTimeout(function(){
   subscriptionaTypeCheck();
}, 1);

    // Video click handling
    $("body").on("click", ".video-upper-image", function () {
        $(".video-upper-image").removeClass("active");
        $(this).addClass("active");

        let imageTarget = $(this).attr("data-image");

        $(".video-main-block").each(function () {
            let videoTarget = $(this).attr("data-video");
            let videoElement = $(this).find("video")[0];

            if (imageTarget === videoTarget) {
                $(this).show();
                if (videoElement) {
                    videoElement.muted = false;
                    videoElement.play();
                }
            } else {
                $(this).hide();
                if (videoElement) {
                    videoElement.pause();
                    videoElement.currentTime = 0;
                    videoElement.muted = true;
                }
            }
        });
    });

    $("body").on("click", ".video-hide", function () {
        $(".video-upper-image").removeClass("active");
        $(".video-main-block").hide();
        $(".video-upper-image").show();
    });

    // Slick slider initialization
    function initSlickSlider(selector, settings) {
        $(selector).slick(settings);
    }

    initSlickSlider(".slider_img_text_outer", {
        centerMode: true,
        autoplay: false,
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendDots: $(".community-slider-icon"),
        responsive: [
            { breakpoint: 1400, settings: { autoplay: true, slidesToShow: 1 } },
            { breakpoint: 1024, settings: { slidesToShow: 1 } },
            { breakpoint: 768, settings: { slidesToShow: 1 } }
        ]
    });

    initSlickSlider(".image_slider_inner", {
        centerMode: true,
        autoplay: false,
        dots: true,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        appendDots: $(".image-slider-icon"),
        responsive: [
            { breakpoint: 1300, settings: { slidesToShow: 2 } },
            { breakpoint: 1024, settings: { slidesToShow: 3 } },
            { breakpoint: 991, settings: { slidesToShow: 2 } },
            { breakpoint: 575, settings: { slidesToShow: 1 } }
        ]
    });

    // Sticky menu functionality
    let stickyLinks = $(".jump_outer");
    let targetSection = $("#benefits");
    let stickyOffset = targetSection.offset().top;
    let sections = $("div[id]");

    $(window).on("scroll", function () {
        let scrollTop = $(window).scrollTop();
        stickyLinks.toggleClass("sticky-fixed", scrollTop >= stickyOffset);

        sections.each(function () {
            let sectionTop = $(this).offset().top - 10;
            let sectionBottom = sectionTop + $(this).outerHeight();

            if (scrollTop >= sectionTop && scrollTop < sectionBottom) {
                let id = $(this).attr("id");
                $(".sticky_links a").removeClass("active");
                $('.sticky_links a[href="#' + id + '"]').addClass("active");
            }
        });
    });

    $(window).on("resize", function () {
        stickyOffset = targetSection.offset().top;
    });


// right menu active js

document.addEventListener("DOMContentLoaded", function () {
  const currentPath = window.location.pathname;
  const menuLinks = document.querySelectorAll(".right_menu_item a");
  menuLinks.forEach(function (link) {
    const linkPath = new URL(link.href).pathname;
    if (currentPath === linkPath) {
      link.classList.add("active");
    }
  });
});


// parallax js function

document.addEventListener("scroll", function () {
  document.querySelectorAll(".parallax").forEach((el) => {
    let rect = el.getBoundingClientRect();
    let scrollPos = window.scrollY;
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      el.style.backgroundPositionY = -(scrollPos * 0.5) + "px";
    }
  });
});


// parallax js function for shop page

// window.addEventListener("scroll", function () {
//   let parallaxElements = document.querySelectorAll(".product-parallax");
//   parallaxElements.forEach((parallax) => {
//     let scrollPosition = window.scrollY;
//     parallax.style.backgroundPositionY = -(scrollPosition * 0.1) + "px";
//   });
// });

  //Subscription options

$(document).on('click','.Subscription_option', function () {
    $('.Subscription_option').removeClass('active');
    $(this).addClass('active');
    var selectedPlan = $("input[name='Selling_plans']:checked").val();
    $("form input[name='selling_plan']").val(selectedPlan);

    if ($(this).hasClass('selling-plan_one_bar')) {
        $("form input[name='selling_plan']").val('');
    }

    if ($(this).hasClass('selling_plan_edition')) {
        var editoroptval = $("input[name='editior_selling_plan']").val();
        $("form input[name='selling_plan']").val(editoroptval);
    }

    if ($('.selling-plan_one_bar input').is(":checked")) {
        $('.subscription_text_one_time').show();
       $('.subscription_text_annual').hide();
    }

    if ($('.Subscription_Tab.month_tab input').is(":checked")) {
        $('.subscription_text_month').show();
        $('.subscription_text_annual').hide();
        var monthlyPrice = $("[name='monthly']").find("span").text();
    $(".sub-price").text(monthlyPrice);
    }
    if ($('.Subscription_Tab.year_tab input').is(":checked")) {
        $('.subscription_text_annual').show();
        $('.subscription_text_month').hide();
       var yearlyPrice = $("[name='annual']").find("span").text();
    $(".sub-price").text(yearlyPrice);
    }




});

});

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".klaviyo_form_trigger").forEach(button => {
    button.addEventListener("click", function () {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", "XNgW4Q"]);

      let checkImageInterval = setInterval(() => {
        let mobileImg = document.querySelector('[alt="bg-img-mobile"]');
        if (mobileImg) {
          let closestNeedsclick = mobileImg.closest('[data-testid="form-row"]');
          if (closestNeedsclick) {
            closestNeedsclick.classList.add("mobile_image");
          }
          clearInterval(checkImageInterval);
        }
      }, 100);
    });
  });

  subscriptionaTypeCheck(); // call your custom function
});


